module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page",
    attrs: {
      "id": "hero"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "linear-wipe",
      "mode": "out-in"
    }
  }, _vm._l((_vm.words), function(word, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selected == i),
        expression: "selected == i"
      }],
      key: i,
      staticClass: "anim-holder"
    }, [_c('h3', [_vm._v(_vm._s(word) + " ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [(_vm.separator) ? _c('span', [_vm._v("...")]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), (_vm.button) ? _c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.button.link
    }
  }, [_vm._v(_vm._s(_vm.button.text))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "shapes"
  }, [_vm._l((7), function(x) {
    return _c('div', {
      staticClass: "diamond"
    })
  }), _vm._v(" "), _vm._l((7), function(x) {
    return _c('div', {
      staticClass: "circle"
    })
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7bab57c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/hero.vue
// module id = 162
// module chunks = 0